import type { FuelCardState } from './reducer';
import { compose } from 'redux';

import type { AppState } from '../AppState';

const selectFuelCard = (state: AppState) => state.fuelCard;

export const selectTransactionsReport = compose((state: FuelCardState) => state.transactionsReportWebData, selectFuelCard);

export const selectTransactions = compose((state: FuelCardState) => state.transactionsWebData, selectFuelCard);

export const selectFuelCardVehicles = compose((state: FuelCardState) => state.vehiclesWebData, selectFuelCard);

export const selectUpdateFuelCardVehicles = compose((state: FuelCardState) => state.updateVehiclesWebData, selectFuelCard);

export const selectFuelCardMatchings = compose((state: FuelCardState) => state.fuelCardMatchingsWebData, selectFuelCard);

export const selectSaveFuelCardMatching = compose((state: FuelCardState) => state.saveFuelCardMatchingWebData, selectFuelCard);
